import Icon from '../components/Icon.vue'

Icon.register({
  'yin-yang': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 384c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM248 256c53 0 96-43 96-96s-43-96-96-96c-106 0-192 86-192 192s86 192 192 192c-53 0-96-43-96-96s43-96 96-96zM248 128c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/yin-yang.js
// module id = 2122
// module chunks = 0